
export const PRACTICE_ROUND_LENGTH = 10;
//icon names can be found here 
//https://material.io/resources/icons/?style=baseline
export const menuItems = [
  {
    icon: "view_agenda",
    title: "Game", // was "Dashboard"
    path: "/",
    check: true
  },
  {
    icon: "school",
    title: "Grammar Tips", // was "Lessons"
    path: "/Lessons",
    check: false
  },
  {
    icon: "edit",
    title: "Practice",
    path: "/Practice",
    check: false
  },
  {
    icon: "history_edu",
    title: "Paleography",
    path: "/Paleography",
    check: false
  },
  {
    icon: "font_download",
    title: "Vocabulary",
    path: "/Vocabulary",
    check: false
  },
  // {
  //   icon: "book",
  //   title: "Grammar",
  //   path: "/Grammar",
  //   check: false
  // },
  {
    icon: "camera",
    title: "Conjugate",
    path: "/Conjugate",
    check: false
  },
  {
    icon: "person",
    title: "Profile",
    path: "/Profile",
    check: false
  },
  // {
  //   icon: "settings",
  //   title: "Settings",
  //   path: "/Settings",
  //   check: false
  // },
  {
    icon: "info",
    title: "About",
    path: "/About",
    check: false
  }
];

export const MAX_SRS = 3;
export const SRS_BASE_INTERVAL = 120000;

export const PARTS_OF_SPEECH = {
  noun: 1,
  adjective: 2,
  verb: 3,
  adverb: 4,
  article: 5,
  preposition: 6
};

export const GENDER = {
  masculine: 1,
  feminine: 2,
  masculine_feminine: 3,
  none: 4
};

export const VOWELS = "aeiouáéíóú";

export function getCode(verb) {
  return getVerbCode(verb.verb) +
    getObjCode(verb.depForm, VERB_FORMS) +
    getObjCode(verb.tense, VERB_TENSES) +
    cellCode(verb.person, verb.number);
}

function getObjCode(member, set) {
  var arr = Object.values(set);
  var index = arr.indexOf(member);
  var totalDigits = arr.length.toString().length;
  return index.toString().padStart(totalDigits, "0");
}

function getVerbCode(verb) {
  var index = SAMPLE_VERBS.indexOf(SAMPLE_VERBS.find(v => v.verb === verb));
  var totalDigits = SAMPLE_VERBS.length.toString().length;
  return index.toString().padStart(totalDigits, "0");
}

function cellCode(person, number) {
  var pIndex = Object.values(VERB_PERSON).indexOf(person);
  var nIndex = Object.values(VERB_NUMBER).indexOf(number);
  return (nIndex * 3 + pIndex).toString();
}

export const VERB_TENSES = {
  past: "past",
  present: "present",
  future: "future",
  conditional: "conditional",
  subjunctive: "present subjunctive",
  imperative: "imperative",
  habitual: "past habitual/past subjunctive"
  //more to come
};

export const VERB_NUMBER = {
  singular: "singular",
  plural: "plural"
  // autonomous: "autonomous",
};

export const VERB_PERSON = {
  first: "1st Person",
  second: "2nd Person",
  third: "3rd Person"
};

export const VERB_CATEGORY = {
  first: "Broad 1-Syllable",
  second: "Slender 1-Syllable",
  third: "Broad 2-Syllable",
  fourth: "Slender 2-Syllable"
};

export const VERB_FORMS = {
  independent: "independent",
  negative: "negative",
  interrogative: "interrogative",
};

export const SAMPLE_VERBS = [
  { verb: "glanaidh", cat: VERB_CATEGORY.first, translation: "clean" },
  { verb: "molaidh", cat: VERB_CATEGORY.first, translation: "praise" },
  { verb: "díolaidh", cat: VERB_CATEGORY.first, translation: "pay" },
  { verb: "measaidh", cat: VERB_CATEGORY.first, translation: "think" },
  { verb: "dúnaidh", cat: VERB_CATEGORY.first, translation: "close" },

  { verb: "brisidh", cat: VERB_CATEGORY.second, translation: "break" },
  { verb: "cuiridh", cat: VERB_CATEGORY.second, translation: "put" },
  { verb: "lingidh", cat: VERB_CATEGORY.second, translation: "leap" },
  { verb: "fillidh", cat: VERB_CATEGORY.second, translation: "turn" },

  { verb: "breathnaighidh", cat: VERB_CATEGORY.third, translation: "judge" },
  { verb: "cosnaighidh", cat: VERB_CATEGORY.third, translation: "protect" },
  { verb: "leathnaighidh", cat: VERB_CATEGORY.third, translation: "widen" },
  { verb: "grádhaighidh", cat: VERB_CATEGORY.third, translation: "love" },
  { verb: "mallaighidh", cat: VERB_CATEGORY.third, translation: "curse" },
  { verb: "ceannaighidh", cat: VERB_CATEGORY.third, translation: "purchase" },

  { verb: "mínighidh", cat: VERB_CATEGORY.fourth, translation: "subsubdue" },
  { verb: "céimnighidh", cat: VERB_CATEGORY.fourth, translation: "step" },
  {
    verb: "cuimhnighidh",
    cat: VERB_CATEGORY.fourth,
    translation: "reremember"
  },
  { verb: "oibrighidh", cat: VERB_CATEGORY.fourth, translation: "work" },
  { verb: "soillsighidh", cat: VERB_CATEGORY.fourth, translation: "enlighten" },
  { verb: "aithnighidh", cat: VERB_CATEGORY.fourth, translation: "know" },

  {
    verb: "do-ní",
    cat: "irregular",
    translation: "make",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["do-ním"],
          ["do-ní"],
          ["do-ní"],
          ["do-nímid", "do-nímid", "do-niam", "do-niamaoid", "do-niamaid"],
          ["do-níthí", "do-nithe"],
          ["do-níd", "do-niad"]
        ],

        dependent_forms: [
          ["déanaim", "déinim"],
          ["déana(e)", "déine"],
          ["déanann", "déineann", "déan", "déin"],
          ["déanmaoid", "déanmaid", "déanam", "déineam"],
          ["déantae", "déantaí"],
          ["déanaid", "déinid"]
        ]
      }
    ]
  },
  {
    verb: "do-bheir",
    cat: "irregular",
    translation: "give",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["do-bheirim", "do-bhirim"],
          ["do-bheire", "do-bhire"],
          ["do-bheir", "do-bhir"],
          [
            "do-bheirmíd",
            "do-bhirmíd",
            "do-bhearmaoid",
            "do-bheiream",
            "do-bhiream",
            "do-bhearam"
          ],
          ["do-bheirthe"],
          ["do-bheirid"]
        ],
        dependent_forms: [
          ["tabhraim"],
          ["tabhra", "tabhrae"],
          ["tabhair", "tabhrann"],
          ["tabhairmíd", "tabhairmid", "tabharmaoid", "tabharmaid", "tabhram"],
          ["tabhairthe"],
          ["tabhraid"]
        ]
      }
    ]
  },
  {
    verb: "do-gheibh",
    cat: "irregular",
    translation: "get",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["do-gheibhim"],
          ["do-gheibhe"],
          ["do-gheibh"],
          [
            "do-gheibheam",
            "do-ghabham",
            "do-gheibhmíd",
            "do-gheibhmid",
            "do-ghabhmaoid",
            "do-ghabhmaid"
          ],
          ["do-gheibhthí", "do-gheibhthe", "do-ghabhthaoi"],
          ["do-gheibhid", "do-ghabhaid"]
        ],
        dependent_forms: [
          [
            "faghbhaim",
            "faghaim",
            "aghbhaim",
            "aghaim",
            "foghbhaim",
            "foghaim",
            "oghbhaim",
            "oghaim"
          ],
          [
            "faghbha",
            "fagha",
            "faghbhae",
            "faghae",
            "foghbha",
            "fogha",
            "foghbhae",
            "foghae",
            "aghbha",
            "agha",
            "aghbhae",
            "aghae",
            "oghbha",
            "ogha",
            "oghbhae",
            "ogha"
          ],
          [
            "fagh",
            "fogh",
            "faghaibh",
            "foghaibh",
            "aghann",
            "oghann",
            "aghbhann",
            "oghbhann"
          ],
          [
            "faghbham",
            "fagham",
            "foghbham",
            "fogham",
            "agham",
            "aghbham",
            "ogham",
            "oghbham",
            "faghbhmaoid",
            "faghmaoid",
            "foghbhmaoid",
            "foghmaoid",
            "aghbhmaoid",
            "aghmaoid",
            "oghbhmaoid",
            "oghmaoid"
          ],
          [
            "faghthaoi",
            "foghthaoi",
            "aghthaoi",
            "oghthaoi",
            "faghaibhthí",
            "foghaibhthí",
            "aghaibhthí",
            "oghaibhthí",
            "faghaibhthe",
            "foghaibhthe",
            "aghaibhthe",
            "oghaibhthe"
          ],
          [
            "faghaid",
            "foghaid",
            "aghaid",
            "oghaid",
            "faghbhaid",
            "foghbhaid",
            "aghbhaid",
            "oghbhaid"
          ]
        ]
      }
    ]
  },
  {
    verb: "do-chluin",
    cat: "irregular",
    translation: "hear",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["do-chluinim", "ad-chluinim"],
          ["do-chluine", "ad-chluine"],
          ["do-chluin", "ad-chluin", "do-chluineann", "ad-chluinneann"],
          ["do-chluinmíd", "ad-chluinmíd", "do-chluineam", "ad-chluineam"],
          ["do-chluinte", "ad-chluinte", "do-chluintí", "ad-chluintí"],
          ["do-chluinid", "ad-chluinid"]
        ],
        dependent_forms: [
          ["cluinim"],
          ["cluine"],
          ["cluin", "cluineann"],
          ["cluinmíd", "cluineam"],
          ["cluinte", "cluintí"],
          ["cluinid"]
        ]
      }
    ]
  },
  {
    verb: "téid",
    cat: "irregular",
    translation: "go",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["téighim", "do-éighim"],
          ["téighe", "do-éighe"],
          ["téid", "do-éid"],
          [
            "téighmíd",
            "do-éighmíd",
            "tiaghmaíd",
            "do-iaghmaíd",
            "tiachmaíd",
            "do-iachmaíd",
            "do-éigheam",
            "do-iagham",
            "do-iacham"
          ],
          ["téighthe", "téighthí"],
          ["tiaghaid", "tiad"]
        ],
        dependent_forms: [["téighim"], ["téighe"], ["téid"], ["tiaghmaíd"],[""],[""]]
      }
    ]
  },
  {
    verb: "do-chí",
    cat: "irregular",
    translation: "see",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["do-chím", "ad-chím", "do-chiú", "ad-chiú"],
          ["do-chí", "ad-chí"],
          ["do-chí", "ad-chí"],
          [
            "do-chímid",
            "do-chímíd",
            "ad-chímid",
            "ad-chímíd",
            "do-chiamaid",
            "do-chiamaoid",
            "do-chiam",
            "ad-chiam"
          ],
          ["do-chíthí", "ad-chíthí", "do-chíthe", "ad-chíthe"],
          ["do-chíd", "ad-chíd", "do-chiad", "ad-chiad"]
        ],
        dependent_forms: [
          ["faicim"],
          ["faice"],
          ["faic", "faiceann"],
          ["faicmid", "faicmíd", "faiceam"],
          ["faicthe", "faicthí"],
          ["faicid", "faicead"]
        ]
      }
    ]
  },
  {
    verb: "tig",
    cat: "irregular",
    translation: "come",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["tigim", "do-igim"],
          ["tige", "do-ige"],
          ["tig", "do-ig"],
          [
            "tigmíd",
            "tigimid",
            "do-igmíd",
            "do-igmid",
            "do-igeam",
            "teagmaoid",
            "do-eagmaoid",
            "do-eagam"
          ],
          ["tigthe", "tigthí,", "do-igthe", "do-igthí"],
          ["tigid", "do-igid", "teagaid"]
        ],
        dependent_forms: [
          ["tigim"],
          ["tige"],
          ["tig"],
          ["tigimíd", "tigimid", "tigeam", "teagmaoid", "teagam"],
          ["tigthí"],
          ["tigid", "teagaid"]
        ]
      }
    ]
  },
  {
    verb: "a-tá",
    cat: "irregular",
    translation: "be",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["a-tú"],
          ["a-taoi"],
          ["a-tá"],
          ["a-tám", "a-támaid", "a-támaoid"],
          ["a-táthaoi", "a-táithe", "a-táidh"],
          ["a-tád", "a-táid"]
        ],
        dependent_forms: [
          ["fuilim", "foilim", "uilim", "oilim"],
          ["fuile", "foile", "uile", "oile"],
          ["fuil", "foil", "uil", "oil"],
          [
            "fuilmíd",
            "foilmíd",
            "fuileam",
            "foileam",
            "uilmíd",
            "oilmíd",
            "uileam",
            "oileam"
          ],
          [
            "fuiltí",
            "fuilte",
            "foiltí",
            "foilte",
            "uiltí",
            "uilte",
            "oiltí",
            "oilte"
          ],
          ["fuilid", "foilid", "uilid", "oiled"]
        ]
      }
    ]
  },
  {
    verb: "Bí",
    cat: "irregular",
    translation: "be",
    tables: [
      {
        tense: VERB_TENSES.present,
        independent_forms: [
          ["bím"],
          ["bí"],
          ["bídh"],
          ["bímíd"],
          ["bíthe", "bíthí"],
          ["bíd"]
        ],
        dependent_forms: [
          ["bím"],
          ["bí"],
          ["bí", "bíonn"],
          ["bíom", "bímíd"],
          ["bíthe", "bíthí"],
          ["bíd", "bíod"]
        ]
      }
    ]
  }
];

export const REGULAR_VERBS = SAMPLE_VERBS.filter(verb => verb.cat !== "irregular")
export const IRREGULAR_VERBS = SAMPLE_VERBS.filter(verb => verb.cat === "irregular")
export const QUESTION_TYPES = [
  "verb","custom", "regular", "paleo"
]
export const VERB_QUESTION_TYPES = [
  "parameters to conjugation",
  "conjugation to parameters",
  "translation to conjugation",
  "conjugation to translation"
];

export const VERB_LESSON_MAP = [
  {
    level: 3,
    lesson: 7,
    tense: [VERB_TENSES.present], //yes, these should be arrays since we have to sample them
    categories: [VERB_CATEGORY.first, VERB_CATEGORY.second]
  },
  {
    level: 3,
    lesson: 8,
    tense: [VERB_TENSES.present],
    categories: [VERB_CATEGORY.third, VERB_CATEGORY.fourth]
  },
  {
    level: 3,
    lesson: 9,
    tense: [VERB_TENSES.past],
    categories: [VERB_CATEGORY.first, VERB_CATEGORY.second]
  },
  {
    level: 3,
    lesson: 10,
    tense: [VERB_TENSES.past],
    categories: [VERB_CATEGORY.third, VERB_CATEGORY.fourth]
  },
  {
    level: 3,
    lesson: 11,
    tense: [VERB_TENSES.future],
    categories: [VERB_CATEGORY.first, VERB_CATEGORY.second]
  },
  {
    level: 3,
    lesson: 12,
    tense: [VERB_TENSES.future],
    categories: [VERB_CATEGORY.third, VERB_CATEGORY.fourth]
  },
  {
    level: 3,
    lesson: 13,
    tense: [VERB_TENSES.conditional],
    categories: [VERB_CATEGORY.first, VERB_CATEGORY.second]
  },
  {
    level: 3,
    lesson: 14,
    tense: [VERB_TENSES.conditional],
    categories: [VERB_CATEGORY.third, VERB_CATEGORY.fourth]
  },
  {
    level: 3,
    lesson: 15,
    tense: [VERB_TENSES.present,VERB_TENSES.past,VERB_TENSES.future ,VERB_TENSES.conditional],
    categories: [VERB_CATEGORY.first, VERB_CATEGORY.second, VERB_CATEGORY.third, VERB_CATEGORY.fourth]
  }
];

// export const IRREGULAR_VERBS = [
//   {
//     verb: "do-ním", cat: translations: ["make", "do"],
//     independent_forms: [["do-ním"],["do-ní"],["do-ní"],
//     ["do-nímid","do-nímid","do-niam","do-niamaoid","do-niamaid"],["do-níthí","do-nithe"],["do-níd","do-niad"]] ,
//     dependent_forms: [["déanaim","déinim"],["déana(e)","déine"],["déanann","déineann","déan","déin"],
//   ["déanmaoid","déanmaid","déanam","déineam"],["déantae","déantaí"],["déanaid","déinid"]]
//   }
// ]
